// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__JRZL4","approved":"Status_approved__wiK1y","rejected":"Status_rejected__2UPAZ","expired":"Status_expired__16arz","label":"Status_label__22nti"};